import { type App, type InjectionKey, type Plugin } from "vue";

export const appProvideKey = Symbol("app") as InjectionKey<App>;

export const vueAppPlugin = {
  install(app) {
    app.provide(appProvideKey, app);
  },
} satisfies Plugin;
